import React from 'react'
import { getFileName } from '../../../helpers/FileCaching';
import WorldNews from '../../App/WorldNews/WorldNews';
import classes from './Introduction.module.scss'
import globalJSON from 'data/global.json'

const introductionImages = require.context('../../../images/components/Introduction', true, /.*\.(gif|png|jpe?g|svg)$/i);

function Introduction(props){
	return (
		<section id={"introduction"} className={classes.introduction}>
			<div className={classes.introduction__container}>
				<div className={classes.introduction__world_news_wrapper}>
					<WorldNews content={globalJSON.globalAiringTimes}/>
				</div>
				
				<div className={classes.introduction__image} >
					<div className={classes.introduction__logo}
						style={
							{
							backgroundImage: 'url(' + getFileName(introductionImages, props.content[0].logo) + ')'
							}										
						}
						title="Follow the food"
					></div>

				</div>

			</div>
		</section>
		
	)
}

export default Introduction